import type { ListNotificationsResponse } from "@scoach/types";

import { api } from "../../lib/http.ts";

export const notificationsApi = {
  list: () => api<ListNotificationsResponse>("/users/me/notifications"),
  markRead: (ids?: string[]) =>
    api<{ ok: boolean }>("/users/me/notifications/read", { method: "POST", body: { ids } }),
};
